import { Component, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from 'src/app/share/services/common-service/common-service.service';
import { DayBookService } from 'src/app/share/services/day-book/day-book.service';
import { faBox, faChevronRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-day-returns-from-customer',
  templateUrl: './day-returns-from-customer.component.html',
  styleUrl: './day-returns-from-customer.component.scss',
  standalone: false,
})
export class DayReturnsFromCustomerComponent implements OnChanges {

  @Output() hasData = new EventEmitter<boolean>();

  protected readonly faBox = faBox;
  protected readonly faChevronRight = faChevronRight;

  @Input() selectedDate: any;
  @Input() selectedBranch: any;

  totalEntries: number = 0;
  totalAmount: number = 0;
  returnsFromCustomer: any[] = [];
  loader: boolean = false;
  errMsg: string = "";

  constructor(
    private readonly dayBookService: DayBookService,
    private readonly modalService: NgbModal,
    private readonly cmsService: CommonServiceService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedDate'] || changes['selectedBranch']) {
      this.totalEntries = 0;
      this.totalAmount = 0;
      this.returnsFromCustomer = [];
      this.getData();
    }
  }


  getData() {
    this.loader = true;
    this.errMsg = '';
    let params: any = {
      created_date: this.selectedDate
    }
    if (this.selectedBranch) {
      params.company = this.selectedBranch
    }
    this.dayBookService.getDayReturnsFromCustomer(params).subscribe({
      next: (res: any) => {
        this.loader = false
        this.mapResponse(res.data || [])
      },
      error: (err: any) => {
        this.loader = false;
        this.errMsg = err.error.error.message || "Failed to fetch response";
        this.hasData.emit(false);
      }
    })
  }

  mapResponse(data: any) {
    this.hasData.emit(!!(data && data.length > 0));
    if (!data || data?.length == 0) this.errMsg = "No data found"
    if (!Array.isArray(data)) return;
    let tableData = data.map((item: any) => {
      return {
        ...item,
        quantity: this.cmsService.parseNumberOrNull(item.quantity)
      };
    });
    this.returnsFromCustomer = tableData;
  }

  viewAllReturns(modalContent: any) {
    this.modalService.open(modalContent, { size: 'lg', centered: true, scrollable: true });
  }

}
